// import firebase from "firebase/app";
// import "firebase/firestore";
// import 'firebase/auth';
// import "firebase/storage";

// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp } from "@firebase/app";
import { getFirestore } from "@firebase/firestore";

if (process.env.NODE_ENV !== 'production') {
  require('dotenv').config()
}

// var email = process.env.VUE_APP_EMAIL;
// var password = process.env.VUE_APP_PASSWORD; 

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY, 
  authDomain: process.env.VUE_APP_AUTHDOMAIN, 
  databaseURL: process.env.VUE_APP_DATABASEURL, 
  projectId: process.env.VUE_APP_PROJECTID, 
  storageBucket: process.env.VUE_APP_STORAGEBUCKET, 
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID, 
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};
// Initialize Firebase
// firebase.initializeApp(firebaseConfig);
initializeApp(firebaseConfig);

// Authenticate to Firebase
// firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
//   // Handle Errors here.
//   console.log(error.code);
//   console.log(error.message);
//   // ...
// });

// initisalise firebase connect and store in constant db
// const db = firebase.firestore();
const db = getFirestore()

export default db;
